'use client';

import { Suspense } from 'react';
import { useSearchParams } from 'next/navigation';
import { TypeformApply } from '@/components/apply/TypeformApply';
import { useLocale } from '@/lib/i18n/LocaleContext';
import { pageCopy } from '@/lib/i18n/pageCopy';
import { applyCopy } from '@/lib/i18n/pages/apply';

function ApplyFormWithParams() {
  const params = useSearchParams();
  return <TypeformApply initialPosition={params.get('position')} />;
}

export function ApplyPageClient() {
  const { locale, dir } = useLocale();
  const t = pageCopy(applyCopy, locale);
  return (
    <Suspense
      fallback={
        <p role="status" dir={dir} style={{ padding: '32px' }}>
          {t.states.loading}
        </p>
      }
    >
      <ApplyFormWithParams />
    </Suspense>
  );
}
